<template>
  <div class="kee">
    <div class="title">
      <svg-icon icon-name="icon-kee-title" :size="16" class="mr-5"></svg-icon>
      <span>{{ $t('clientDashboard.KEE') }}</span>
    </div>
    <div class="__content">
      <template v-for="(item, index) in menu">
        <div class="wl-client-item" :class="'item' + (index + 1)" @click="clickCourseList(item)">
          <div class="img-box">
            <img :src="item.src" />
          </div>
          <div class="info">
            <div :class="['iconNew', $i18n.locale === 'en' ? '__en' : '']" v-if="newTag[item.newTag]"></div>
            <p :style="'color: ' + getFontColor(index)" :class="[$i18n.locale === 'en' ? 'en-fontSize name' : ' name']">
              {{ $t(item.name) }}
            </p>
            <el-tooltip :content="$t(item.desc)" placement="top">
              <p class="desc">{{ $t(item.desc) }}</p>
            </el-tooltip>
          </div>
        </div>
      </template>
    </div>
  </div>
</template>

<script>
import SvgIcon from "@/components/svgIcon/index";
import API from '@/api'

import { insightsList } from './data'

export default {
  name: 'MidPolicy',
  components: {
    SvgIcon
  },
  data() {
    return {
      newTag: {},
      colorList: ['#00338d', '#00b8f5', '#3879EB', '#fd349c', '#7213ea'],
      menu: [
        { 
          desc: 'kee_menu_1_desc',
          name: "kee_menu_1",
          src: require("@/assets/img/Insights-icon – 1.png"),
          tag: "ACCOUNTING_COURSE", 
          newTag: "accountingCourseNewFlag"
        },
        { 
          desc: 'kee_menu_2_desc',
          name: "kee_menu_2",
          src: require("@/assets/img/Insights-icon – 2.png"),
          tag: "TAX_COURSES", 
          newTag: "taxCoursesNewFlag"
        },
        { 
          desc: 'kee_menu_3_desc',
          name: "kee_menu_3",
          src: require("@/assets/img/Insights-icon – 3.png"),
          tag: "DEVELOPMENT_COURSES", 
          newTag: "developmentCoursesNewFlag"
        },
        { 
          desc: 'kee_menu_4_desc',
          name: "kee_menu_4",
          src: require("@/assets/img/Insights-icon – 4.png"),
          tag: "AUDIT_COOPERATION", 
          newTag: "auditCooperationNewFlag"
        },
        // {name: "kee_menu_5", src: require("@/assets/img/Insights-icon – 5.png")},
      ],
    }
  },
  computed: {
    dataList() {
      return [...insightsList[this.$i18n.locale]]
    },
    // colorList() {
    //   return ['#00338d', '#1e49e2', '#7213ea']
    // },
  },
  methods: {
    getTagStatus() {
      API.insights.queryTagStatus().then(res => {
        if (res.code === '1') {
          this.newTag = res.data
        } else {
          this.$message.error(this.$t(res.code));
        }
      })
    },
    clickCourseList(item) {
      if (item.tag) {
        this.$router.push({ name: "newKee", query: { kccTag: item.tag } })
      } else {
        this.$router.push({ name: "csConsult" })
      }
    },
    getFontColor(index) {
      return this.colorList[index]
    },
  },
  mounted() {
    this.getTagStatus();
  },
}
</script>

<style scoped>
.kee {
  height: 100%;

  --spacing: 15px;
  --title-height: 46PX;
  --item-height: 56PX;
}

.kee .title {
  height: var(--title-height);
  display: flex;
  align-items: center;
  font-weight: 600;

  font-size: 12PX;
}

.kee .__content {
  height: calc(100% - var(--title-height));
  overflow-y: overlay;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  padding-bottom: 15px;
}

.kee .__content .wl-client-item {
  display: flex;
  border: 1px solid #ebebeb;
  border-radius: 5px;
  padding: 10px;
  height: calc((100% - 45px) / 4);
  position: relative;
  cursor: pointer;
}

.wl-client-item:last-child {
  margin-bottom: 0;
}

.wl-client-item .img-box {
  border-radius: 5px;
  background-color: #f5f5f5;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-right: 10px;

flex-shrink: 0;
 width: 100px;
 height: 100%;
}

.wl-client-item .info {
  display: flex;
  flex-direction: column;
  justify-content: space-around;
  flex: 1;
  width: calc(100% - 110px);
}

.wl-client-item .info .iconNew {
  display: inline-block;
  position: absolute;
  background: url("~@/assets/img/icon-new-left-cn.png") center center/100% 100% no-repeat;
  width: 55PX;
  height: 28PX;
  right: 10px;
  top: 10px;
}

.wl-client-item .info .iconNew.__en {
  width: 40PX;
  height: 25PX;
  background: url("~@/assets/img/icon-new-left-en.png") center center/100% 100% no-repeat;
}

.wl-client-item .info .name {
  font-size: 16PX;
  font-weight: 600;
}

.wl-client-item .info .desc {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  color: #a09c9c;
  font-size: 11PX;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}

.name.en-fontSize {
  font-size: 20PX !important;
  font-family: 'Open Sans Condensed', Arial, Helvetica, sans-serif;
}

.img-box img {
  width: 50%;
}

.kee .__content::-webkit-scrollbar {
  width: 6PX !important;
  /*高宽分别对应横竖滚动条的尺寸*/
  height: 6PX !important;
}

.kee .__content::-webkit-scrollbar-thumb {
  /*滚动条里面小方块*/
  border-radius: 11PX;
  background-color: transparent !important;
  transition: background-color 0.3s;
}

.kee .__content:hover::-webkit-scrollbar-thumb {
  background-color: hsla(220, 4%, 58%, 0.3) !important;
}

.kee .__content .item {
  display: flex;
  align-items: center;
  border-radius: 5px;
  cursor: pointer;
  margin-bottom: 10px;
  border: 1px solid #ebebeb;
  border-radius: 5px;
  overflow: hidden;
  height: var(--item-height);
}

.kee .__content .item:last-child {
  margin-bottom: 0;
}
</style>